import { writable } from 'svelte/store';

export const searchStr = writable("");

export const searchRes = writable([]);